import Column from '@components/Column';
import styled from '@emotion/styled';
import { EventResponse } from '@models/event';
import { useTranslation } from 'react-i18next';

interface Props {
    event: EventResponse;
}

function EventContent({ event }:Props) {
    const { content } = event;
    const { i18n: { language } } = useTranslation();
    return (
        <Column fullWidth>
            <Wrapper lang={language}
                dangerouslySetInnerHTML={{ __html: content }}/>
        </Column>
    );
}

const Wrapper = styled.div`
    padding: 0 20px 40px;
    color: var(--color-gray7);
    font-size: 14px;
    line-height: 1.4;
    overflow: hidden;
    width: 100%;
    max-width: 100%;
    font-weight: 400;

    img {
        max-width: 100%;
        -webkit-user-drag: none;
        -khtml-user-drag: none;
        -moz-user-drag: none;
        -o-user-drag: none;
        user-drag: none;
        -webkit-user-select: none;
        -khtml-user-select: none;
        -moz-user-select: none;
        -o-user-select: none;
        user-select: none;
    }

    ul {
        list-style-type: disc;
        list-style-position: outside;
        display: block;
        padding-left: 16px;
    }

    ol {
        list-style-type: decimal;
        list-style-position: outside;
        padding-inline-start: 16px;
    }

    li {
        display: list-item;
    }

    h1, h2, h3 {
        font-weight: 400;
    }

    h1 {
        font-size: 24px;
    }

    h2 {
        font-size: 20px;
    }

    h3 {
        font-size: 16px;
    }

    p {
        font-size: 14px;
        min-height: 20px;
    }
`;

export default EventContent;
